/*
 *  (c) 2015 - 2024 ENISCO by FORCAM GmbH
 */

import {useSelector} from 'react-redux'
import {App} from '../model/apps'
import {AppRootState} from '../model/config'
import {Favorite} from '../model/favorites'
import {useParameters} from '@enisco/mcc-react-lib'
import useFavoriteId from './useFavoriteId'
import {useNavigate} from 'react-router-dom'
import {pathToFavorite} from '../util/navigation'

const setApp = (app: App, favorite: Favorite) => {
  return {
    app: app.app,
    module: app.module,
    favoriteId: favorite.id,
    icon: app.icon,
    description: favorite.description,
    hidden: false,
    url: `/mcc-portal-ui/favorites/${favorite.id}`,
    hasAccess: app.hasAccess,
    order: app.order
  }
}

const useFavoriteApp = (): [
  App | undefined,
  (favoriteApp: Favorite) => void
] => {
  const [favoriteId] = useFavoriteId()
  const [, setParameters] = useParameters()
  const navigate = useNavigate()
  const currentFavorite = useSelector(
    (state: AppRootState) => state.app.favoriteApp
  )
  const registeredFavorites = useSelector(
    (state: AppRootState) => state.app.favoriteApps
  )
  const registeredApps = useSelector(
    (state: AppRootState) => state.app.registeredApps
  )
  let app = undefined
  let favorite = currentFavorite

  if (favorite) {
    favorite = favoriteId
      ? registeredFavorites.find((fav) => fav.id === favoriteId)
      : undefined
  }

  if (favorite) {
    const fav = favorite
    const selectedApp = registeredApps.filter(
      (a) => a.module === fav.app.module && a.app === fav.app.app
    )
    if (selectedApp.length > 0) {
      app = setApp(selectedApp[0], fav)
    }
  }

  return [
    app,
    (favoriteApp: Favorite) => {
      if (favoriteApp?.id && Object.keys(favoriteApp).length !== 0) {
        setParameters(favoriteApp.parameters)
        navigate({pathname: pathToFavorite(favoriteApp.id)})
      }
    }
  ]
}

export default useFavoriteApp
